import Header from "./components/Header";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Categories from "./components/Categories";
import Videos from "./components/Videos";
import Topics from "./components/Topics";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs } from "@/mocks/guagua";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

const pageJsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "吃瓜视频网 - 热点合集与事件短视频",
  description:
    "聚合全网热点事件短视频，实时跟进热门瓜与焦点视频，快速围观事件现场，话题视频一网打尽。",
  inLanguage: "zh-CN",
  isPartOf: { "@type": "WebSite", name: "吃瓜视频网" },
};

function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageJsonLd) }}
      />

      <Header />
      <main>
        <Hero />
        <HotList />
        <Categories />
        <Videos />
        <Topics />
        <Testimonials />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default Home;